export default __webpack_public_path__ + "static/media/twitter1.c1625285.svg";